import {SALES_DETAIL_TYPE_KEY_TYPE} from "@/shared/model";
import * as z from "zod";

const schema = z.object({type: SALES_DETAIL_TYPE_KEY_TYPE, content: z.string()});

const model = schema.transform((values) => ({
	...values
}));

export const SalesManagementAddModel = {schema, model};
export type ISalesManagementAddModel = z.infer<typeof SalesManagementAddModel.model>;
export const DEFAULT_SALES_MANAGEMENT_ADD: ISalesManagementAddModel = {
	content: "",
	type: "YEARLY_ACTION_PLAN"
};
